import React from 'react';

const MLetterViewer = ({ base64, onClose }) => {
    return (
        <div>
            <iframe
                src={`data:application/pdf;base64,${base64}`}
                style={{ width: '100%', height: '98vh' }}
                title="Motivation Letter"
            />
        </div>
    );
};

export default MLetterViewer; 